import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EField, FieldRow } from './EditableField';

export default function SectionHero({
  tagline = '', title = '', subtitle = '', button_text = '', button_url = '/', price_note = '', image_src = '',
  mode = 'view', onChange,
}) {
  const set = (k) => (v) => onChange?.({ [k]: v });
  return (
    <section className="relative overflow-hidden bg-ee-bg2 bg-gold-glow">
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(196,161,68,0.12), transparent)' }} />
      <div className="ee-container relative grid lg:grid-cols-2 gap-12 lg:gap-16 py-20 md:py-28 items-center">
        <div className="animate-fade-in">
          {mode === 'edit' ? (
            <FieldRow label="Tagline"><EField value={tagline} onChange={set('tagline')} mode={mode} /></FieldRow>
          ) : (
            tagline && <div className="inline-flex items-center px-3 py-1 mb-6 rounded-full border border-gold/30 bg-gold/5 text-gold text-xs tracking-[0.2em] uppercase">{tagline}</div>
          )}

          {mode === 'edit' ? (
            <FieldRow label="Title (use \n for line break)"><EField multiline value={title} onChange={set('title')} mode={mode} className="text-3xl hero-title" /></FieldRow>
          ) : (
            <h1 className="hero-title text-5xl md:text-6xl lg:text-7xl text-white mb-6">
              <EField value={title} mode="view" as="span" />
            </h1>
          )}

          {mode === 'edit' ? (
            <FieldRow label="Subtitle"><EField multiline value={subtitle} onChange={set('subtitle')} mode={mode} /></FieldRow>
          ) : (
            <p className="text-lg md:text-xl text-ee-text2 mb-8 leading-relaxed max-w-xl">{subtitle}</p>
          )}

          <div className="flex flex-wrap items-center gap-4">
            {mode === 'edit' ? (
              <div className="w-full grid gap-2">
                <FieldRow label="Button Text"><EField value={button_text} onChange={set('button_text')} mode={mode} /></FieldRow>
                <FieldRow label="Button URL"><EField value={button_url} onChange={set('button_url')} mode={mode} /></FieldRow>
                <FieldRow label="Price Note"><EField value={price_note} onChange={set('price_note')} mode={mode} /></FieldRow>
                <FieldRow label="Image URL"><EField value={image_src} onChange={set('image_src')} mode={mode} /></FieldRow>
              </div>
            ) : (
              <>
                <Link to={button_url || '/'} className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md gold-grad text-black font-semibold shadow-lg shadow-gold/20 hover:shadow-gold/40 transition-all hover:-translate-y-0.5">
                  {button_text || 'Get Started'}<ArrowRight size={18} />
                </Link>
                {price_note && <span className="text-sm text-ee-muted">{price_note}</span>}
              </>
            )}
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end">
          <div className="relative w-full max-w-md">
            <div className="absolute -inset-4 bg-gold/20 blur-3xl rounded-full opacity-50" />
            {image_src ? (
              <img src={image_src} alt={title} className="relative rounded-xl shadow-2xl shadow-black/60 border border-gold/20 w-full h-auto" />
            ) : (
              <div className="relative aspect-[3/4] rounded-xl bg-ee-card2 border border-gold/20 flex items-center justify-center text-ee-muted">Book Cover</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
